/* Sockly theme interactions */

document.addEventListener('DOMContentLoaded', () => {
  /* Quantity controls outside the cart (for example, product page). */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qty]');
    if (!button) return;
    const input = button.parentElement && button.parentElement.querySelector('input');
    if (!input) return;

    const min = Number.isFinite(parseInt(input.min, 10)) ? parseInt(input.min, 10) : 1;
    const current = Number.isFinite(parseInt(input.value, 10)) ? parseInt(input.value, 10) : min;
    const next = current + (button.dataset.qty === 'plus' ? 1 : -1);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product page gallery + variants + Buy Now. */
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const mainImage = section.querySelector('#SocklyMainProductImage');
    const thumbs = [...section.querySelectorAll('[data-product-thumb]')];
    let active = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const showIndex = (index) => {
      if (!mainImage || !thumbs.length) return;
      active = (index + thumbs.length) % thumbs.length;
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === active));
      mainImage.src = thumbs[active].dataset.image;
      mainImage.removeAttribute('srcset');
    };

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showIndex(i)));
    const prev = section.querySelector('[data-gallery-prev]');
    const next = section.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', () => showIndex(active - 1));
    if (next) next.addEventListener('click', () => showIndex(active + 1));

    const form = section.querySelector('[data-product-form]');
    const variantsNode = section.querySelector('[data-product-variants]');
    if (!form || !variantsNode) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent || '[]'); } catch (error) { variants = []; }

    const radios = [...form.querySelectorAll('input[type="radio"][data-option-position]')];
    const idInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('.add-cart-btn');
    const buyNowButton = form.querySelector('[data-buy-now]');

    const syncVariant = () => {
      form.querySelectorAll('.variant-pill').forEach((label) => {
        label.classList.toggle('is-selected', Boolean(label.querySelector('input:checked')));
      });

      const selected = [];
      radios.forEach((radio) => {
        if (radio.checked) selected[Number(radio.dataset.optionPosition) - 1] = radio.value;
      });

      form.querySelectorAll('[data-option-label]').forEach((label) => {
        const pos = Number(label.dataset.optionLabel) - 1;
        if (selected[pos]) label.textContent = selected[pos];
      });

      const match = variants.find((variant) => selected.every((value, i) => !value || variant.options[i] === value));
      if (match && idInput) idInput.value = match.id;

      const available = Boolean(match && match.available);
      [addButton, buyNowButton].forEach((button) => {
        if (!button) return;
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
      });
      if (addButton) {
        const label = addButton.querySelector('span');
        if (label) label.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    };

    radios.forEach((radio) => radio.addEventListener('change', syncVariant));
    syncVariant();

    /* Shopify cart/add supports return_to. This gives a reliable Buy Now path. */
    form.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      const existing = form.querySelector('input[name="return_to"]');
      if (existing) existing.remove();

      if (submitter && submitter.matches('[data-buy-now]')) {
        const returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        returnTo.value = '/checkout';
        form.appendChild(returnTo);
      }
    });
  });

  /* Cart page: quantity +/- and Remove update Shopify cart immediately. */
  const cartSection = document.querySelector('[data-cart-section]');
  if (cartSection) {
    const changeUrl = cartSection.dataset.cartChangeUrl || '/cart/change.js';
    const status = cartSection.querySelector('[data-cart-status]');
    let busy = false;

    const setBusy = (state, message) => {
      busy = state;
      cartSection.classList.toggle('is-updating', state);
      cartSection.querySelectorAll('button, input').forEach((element) => {
        if (state) element.setAttribute('data-was-disabled', element.disabled ? '1' : '0');
        if (state) element.disabled = true;
        else if (element.getAttribute('data-was-disabled') === '0') element.disabled = false;
        if (!state) element.removeAttribute('data-was-disabled');
      });
      if (status) status.textContent = message || '';
    };

    const changeLine = async (line, quantity) => {
      if (busy) return;
      setBusy(true, 'Updating cart…');
      try {
        const response = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        if (!response.ok) throw new Error('Cart update failed');
        await response.json();
        window.location.reload();
      } catch (error) {
        setBusy(false, 'Could not update cart. Please try again.');
      }
    };

    cartSection.addEventListener('click', (event) => {
      const qtyButton = event.target.closest('[data-cart-qty]');
      if (qtyButton) {
        const lineItem = qtyButton.closest('[data-cart-line]');
        const input = lineItem && lineItem.querySelector('[data-cart-quantity-input]');
        if (!lineItem || !input) return;
        const current = parseInt(input.value || '1', 10);
        const next = Math.max(0, current + (qtyButton.dataset.cartQty === 'plus' ? 1 : -1));
        input.value = next;
        changeLine(Number(lineItem.dataset.line), next);
        return;
      }

      const removeLink = event.target.closest('[data-cart-remove]');
      if (removeLink) {
        event.preventDefault();
        const lineItem = removeLink.closest('[data-cart-line]');
        if (!lineItem) return;
        changeLine(Number(lineItem.dataset.line), 0);
      }
    });

    cartSection.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;
      const lineItem = input.closest('[data-cart-line]');
      if (!lineItem) return;
      const quantity = Math.max(0, parseInt(input.value || '0', 10));
      input.value = quantity;
      changeLine(Number(lineItem.dataset.line), quantity);
    });
  }
});
